import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Explore from "./Explore";
// import SideNav from "./SideNav";

const Electricity = () => {
  const [showTracker, setShowTracker] = useState(false);
useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <>
      <Navbar />
      <div className="radial-bg"></div>
      <section
        className="insurance-service position-relative overflow-hidden"
        style={{ zIndex: 1 }}
      >
        <div className="container">
          <div className="row">
            {/* <div className="col-lg-3  d-none d-lg-block">
              <div style={{ position: "relative", height: "100%" }}>
                <SideNav />
              </div>
            </div> */}
            <div className="col-12">
              <div
                className="row justify-content-center text-center"
                // style={{ minHeight: "30vh" }}
              >
                <div className="col-12 ">
                  <h2 className="fw-semibold recharge-title">
                    Electricity Recharge
                  </h2>
                </div>
              </div>

              <div className="container  mt-5 recharge-box ">
                <div className="row justify-content-center align-items-center">
                  <div className="col-12 col-md-8 col-lg-6">
                    <div
                      className="card p-4 shadow recharge-menu mb-5" 
                      style={{ backgroundColor: "#fff", borderRadius: "10px"}}
                    >
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            State
                          </label>
                          <select className="form-control">
                            <option value="">Select your state</option>
                            <option value="Andhra Pradesh">
                              Andhra Pradesh
                            </option>
                            <option value="Arunachal Pradesh">
                              Arunachal Pradesh
                            </option>
                            <option value="Assam">Assam</option>
                            <option value="Bihar">Bihar</option>
                            <option value="Chhattisgarh">Chhattisgarh</option>
                            <option value="Goa">Goa</option>
                            <option value="Gujarat">Gujarat</option>
                            <option value="Haryana">Haryana</option>
                            <option value="Himachal Pradesh">
                              Himachal Pradesh
                            </option>
                            <option value="Jharkhand">Jharkhand</option>
                            <option value="Karnataka">Karnataka</option>
                            <option value="Kerala">Kerala</option>
                            <option value="Madhya Pradesh">
                              Madhya Pradesh
                            </option>
                            <option value="Maharashtra">Maharashtra</option>
                            <option value="Manipur">Manipur</option>
                            <option value="Meghalaya">Meghalaya</option>
                            <option value="Mizoram">Mizoram</option>
                            <option value="Nagaland">Nagaland</option>
                            <option value="Odisha">Odisha</option>
                            <option value="Punjab">Punjab</option>
                            <option value="Rajasthan">Rajasthan</option>
                            <option value="Sikkim">Sikkim</option>
                            <option value="Tamil Nadu">Tamil Nadu</option>
                            <option value="Telangana">Telangana</option>
                            <option value="Tripura">Tripura</option>
                            <option value="Uttar Pradesh">Uttar Pradesh</option>
                            <option value="Uttarakhand">Uttarakhand</option>
                            <option value="West Bengal">West Bengal</option>
                            <option value="Andaman and Nicobar Islands">
                              Andaman and Nicobar Islands
                            </option>
                            <option value="Chandigarh">Chandigarh</option>
                            <option value="Dadra and Nagar Haveli and Daman and Diu">
                              Dadra and Nagar Haveli and Daman and Diu
                            </option>
                            <option value="Delhi">Delhi</option>
                            <option value="Jammu and Kashmir">
                              Jammu and Kashmir
                            </option>
                            <option value="Ladakh">Ladakh</option>
                            <option value="Lakshadweep">Lakshadweep</option>
                            <option value="Puducherry">Puducherry</option>
                          </select>
                        </div>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            Electricity Board
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your Electricity Board"
                          />
                        </div>
                     
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            CA Number
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your connection number"
                          />
                        </div>

                      <div className="d-grid">
                        <button className="btn btn-primary">Processed</button>
                      </div>

                      <div className="mt-4">
                        <span className="d-block mb-2">Already Applied?</span>
                        <button
                          className="btn btn-link p-0 text-decoration-none fw-semibold"
                          onClick={() => setShowTracker(!showTracker)}
                        >
                          Track Your Status now{" "}
                          <i className="bi bi-arrow-right-short fs-5"></i>
                        </button>

                        {showTracker && (
                          <div className="card p-3 mt-3 shadow-sm">
                            <label className="form-label">
                              Application ID / Mobile Number
                            </label>
                            <input
                              type="text"
                              className="form-control mb-2"
                              placeholder="Enter to track your loan"
                            />
                            <button className="btn btn-outline-primary">
                              Track Now
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="position-absolute bottom-0 start-0 end-0"
                style={{
                  height: "19rem",
                  background: "linear-gradient(to top, #F5F2FF, transparent)",
                  zIndex: "-1",
                }}
              />
            </div>
          </div>
        </div>
      </section>
      <Explore />
      <Footer />
    </>
  );
};

export default Electricity;
